import { getCurrency, isMobile } from '@utils/AppUtil';
import { fromISOStringToFormattedDateString } from '@utils/CalendarUtil';

export const getPaymentListingColumns = () => [
  {
    accessor: 'createdAt',
    Header: 'Date',
    sortable: false,
    width: isMobile() ? 80 : 250,
    Cell: (cell) => fromISOStringToFormattedDateString(cell.value, 'MM/DD/YYYY'),
  },
  {
    accessor: 'description',
    Header: 'Description',
    sortable: false,
    width: isMobile() ? 80 : 250,
    Cell: (cell) => cell.value,
  },
  {
    accessor: 'amount',
    Header: 'Amount',
    sortable: false,
    width: isMobile() ? 80 : 250,
    Cell: (cell) => getCurrency(cell.value),
  },
  {
    accessor: 'dueDate',
    Header: 'Due Date',
    sortable: false,
    width: isMobile() ? 80 : 250,
    Cell: (cell) => (cell.value ? fromISOStringToFormattedDateString(cell.value, 'MM/DD/YYYY') : '-'),
  },
  {
    accessor: 'balance',
    Header: 'Balance',
    sortable: false,
    width: isMobile() ? 80 : 250,
    Cell: (cell) => getCurrency(cell.value),
  },
];
